import UAParser from "ua-parser-js";

const detect = () => {
  const parser = new UAParser();
  const root = document.documentElement;
  const os = parser.getOS().name;
  const str = os.replace(/\s+/g, "-").toLowerCase();
  root.classList.add(str);
};

export default detect;
